import { TooltippedIconButton } from '@mews-commander/ui';
import { useDialog, lt } from '@mews/framework';
import { Dialog } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { TextKey } from '@mews-commander/enums';
import IdentityDocumentScanner from '../../../../identityDocumentScanner/containers/IdentityDocumentScanner';

export const ScannerAction = () => {
    const [{ onClose: onScannerDialogClose, active: isScannerDialogActive }, toggleScannerDialog] = useDialog();

    return (
        <>
            <TooltippedIconButton
                onClick={toggleScannerDialog}
                tooltip={lt(TextKey.MewsIdentityScanner)}
                icon={IconName.Scanner}
                type="button"
            />
            <Dialog active={isScannerDialogActive} onClose={onScannerDialogClose} size="medium">
                <IdentityDocumentScanner scope="customerProfile" />
            </Dialog>
        </>
    );
};
